import { Component, OnInit } from "@angular/core";
import {
  AgActionCellRendererComponent,
  AgNumberCountComponent,
} from "../core/components";
import { GrievanceService } from "./grievance.service";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SubGrievanceComponent } from "./sub-grievance/sub-grievance.component";
import { GLOBAL } from "../app.globals";
import { DataShareService } from "../service/data-share.service";
import * as moment from "moment";
import { LocalStorageService } from "../service/local-storage.service";
import { GatePassRequestsService } from "../labour/gate-pass-requests/gate-pass-requests.service";

@Component({
  selector: "app-grievance-management",
  templateUrl: "./grievance-management.component.html",
  styleUrls: ["./grievance-management.component.css"],
})
export class GrievanceManagementComponent implements OnInit {
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private grievanceService: GrievanceService,
    private dateShareService: DataShareService,
    private localStorage: LocalStorageService,
    private gatePassApi: GatePassRequestsService
  ) { }

  contractorType = 1;

  // filter = 0;
  // userEmail = "rakesh.patel@spikyarc.net";
  // userId = 131603;
  // userRoleCode = 101;
  onGridReady(params) {
    params.api.sizeColumnsToFit(); // Columns ko table width ke according fit karega
  }

  rowData = [];
  reqLevelStage: [];
  showAddButton: boolean = false;
  columnDefs = [
    {
      headerName: "#",
      field: "sortCode",
      cellRendererFramework: AgNumberCountComponent,
      headerComponentParams: { enableSorting: false },
      suppressMenu: true,
      headerHeight: 150,
      lockPinned: true,
    },
    {
      headerName: "Grievance No",
      field: "Grievance_Code",
      filterParams: { applyButton: true, clearButton: true },
      lockPinned: true,
    },
    {
      headerName: "Request No",
      field: "RequestNbr",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
      lockPinned: true,
    },
    {
      headerName: "Grievance Subject",
      field: "GrievanceSubject",
      width: 400,
      minWidth: 300,
      filterParams: { applyButton: true, clearButton: true },
      cellStyle: {
        "white-space": "nowrap",
        overflow: "hidden",
        "text-overflow": "ellipsis",
      },
      lockPinned: true,
    },
    {
      headerName: "Contractor",
      field: "Contractor",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Work Order No",
      field: "WorkOrderNo",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Category",
      field: "GrivanceCategory",
      flex: 2,
      filterParams: { applyButton: true, clearButton: true },
      cellStyle: { "white-space": "normal" },
    },
    {
      headerName: "Priority",
      field: "Priority",
      flex: 0.5,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Impact",
      field: "Impact",
      flex: 0.5,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Addressal Date",
      field: "DisGrievancDate",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "-",
    },
    {
      headerName: "Entry Date",
      field: "DateofEntry",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "-",
    },
    {
      headerName: "Expected Date",
      field: "ExpectedDate",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "-",
    },
    {
      headerName: "Status",
      field: "Status",
      flex: 1,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Action",
      field: "",
      flex: 0.8,
      headerComponentParams: { enableSorting: false },
      suppressMenu: true,
      cellRendererFramework: AgActionCellRendererComponent,
    },
  ];

  ngOnInit() {
    this.getGrivanceData();
    this.getStageLevel();
  }

  getGrivanceData() {
    const reqObj = {
      PageNo: 1,
      RowCountPerPage: 100,
      Serach: null,
      SDate: null,
      EDate: null,
      ContactorVendor_Code: null,
      SubContactorVendor_Code: null,
      WorkOrder_Code: null,
      Action: 0, // Default value 0
      RequestType: 0, // Default value 0
      RequestedUserID: GLOBAL.USER_ID, // Logged in UserID
    };
    this.grievanceService.getGrivanceData(reqObj).subscribe((res: []) => {
      this.rowData = res;
    });
  }

  getStageLevel() {
    const res = {
      Filter: {
        RequestType_Code: "108",
        UserID: GLOBAL.USER_ID,
      },
      Fields: [
        {
          KeyName: "RequestType_Code",
          DisplayName: "RequestType",
        },
        {
          keyName: "Plant_Code",
          DisplayName: "Plant",
        },
        {
          keyName: "Priority",
          DisplayName: "PriorityN",
        },
        {
          keyName: "Role_Code",
          DisplayName: "Role",
          ExtraFields: [
            "RequestLevel_Code",
            "Level",
            "Module_Code",
            "Module_Name",
            "IsActive",
            "IsDelete",
            "IsLastLevel",
          ],
        },
      ],
    };
    this.gatePassApi.getRequestStageLevel(res).subscribe((docTypes: any) => {
      this.reqLevelStage = docTypes;
      const priorityOneRoleCodes = this.getPriorityOneRoleCodes(
        this.reqLevelStage
      );
      this.showAddButton = priorityOneRoleCodes.includes(GLOBAL.ROLE_CODE);
    });
  }
  getPriorityOneRoleCodes(response: any): number[] {
    return response
      .flatMap((req: any) => req.Values)
      .flatMap((plant: any) => plant.Values)
      .filter((priorityObj: any) => priorityObj.Priority === 1)
      .flatMap((priorityObj: any) => priorityObj.Values)
      .map((roleObj: any) => roleObj.Role_Code);
  }

  onTabChange(event) {
    // this.getContractorList(event.nextId);
  }

  editContractor(rowData) {
    const modalRef = this.modalService.open(SubGrievanceComponent, {
      size: "lg",
      backdrop: "static",
      windowClass: "regular-attendence-approval-modal modal-scrollbar-hide",
    });
    modalRef.componentInstance.editData = rowData;
  }

  deleteContractor(index) {
    this.rowData.splice(index, 1);
  }
  public addButton(): void {
    this.modalService.open(SubGrievanceComponent, {
      size: "lg",
      backdrop: "static",
      windowClass: "regular-attendence-approval-modal modal-scrollbar-hide",
    });
  }
}
